import React from "react";
import { Link } from "react-router-dom";
import { Button } from "cxa-components";
import { FormattedMessage } from "react-intl";
import { AccountInfoIcon, CloseIcon } from "cxa-icons";
import { ProgressBar, DonutChart } from "cxa-components";
import classnames from "classnames";
import walletProps from "./walletProps";
import accounting from "accounting";
import StandardMoney from "../../common/StandardMoney";

// Pure Wallet component (or, with as little business logic as possibly)
const Wallet = ({
  walletName = "default name",
  totalPrefix = "default total prefix",
  buttonText = "default button text",
  subtext = "default subtext",
  totalBalance = 1000000,
  spentAmount = 900000,
  href = "/default",
  linkTitle = "default link title",
  isShowingButton = true,
  onClick = () => {},
  isSaving = false,
  items = [],
  currency,
  balanceRatio = 0.0,
  remainingText = "default remaining text",
  remainingBalance = 100000,
  donutChartPrefix = "You have selected",
  donutChartTotalPrefix = "Total",
  isMiniWalletExpanded = false,
  isNarrowScreen = false,
  toggleMiniWalletExpanding,
  showGraph,
}) => {
  const remainingBalanceValue = accounting.unformat(remainingBalance).toFixed(2);
  return (
    <article
      className={classnames("card apl-wallet", isMiniWalletExpanded && "apl-wallet--expanded")}
    >
      <header>
        {walletName}
        {isNarrowScreen && (
          <Button
            tertiary
            onClick={toggleMiniWalletExpanding}
            className="cxa-mini-wallet__button cxa-mini-wallet__button--expanded"
          >
            <CloseIcon />
          </Button>
        )}
      </header>
      <section className="apl-wallet__total">
        <h4>{totalPrefix}</h4>
        <p className="apl-wallet__balance">
          <StandardMoney value={totalBalance} currency={currency} postfix />
        </p>
        <p className="apl-wallet__statement">
          <Link to={href}>
            {linkTitle}
            <AccountInfoIcon />
          </Link>
        </p>
      </section>
      {showGraph && (
        <section>
          <div className="apl-wallet__donutchart">
            <h4>
              <FormattedMessage id={donutChartPrefix} defaultMessage={donutChartPrefix} />
            </h4>
            <div className="apl-wallet__donutchart--donutchart">
              <DonutChart segments={items} />
            </div>
            <div className="apl-wallet__donutchart--total">
              <p>
                <FormattedMessage
                  id={donutChartTotalPrefix}
                  defaultMessage={donutChartTotalPrefix}
                />
                <br />
                <StandardMoney value={spentAmount} currency={currency} postfix />
              </p>
            </div>
          </div>
        </section>
      )}
      <section>
        <div className="apl-wallet__lineitems">
          {items.map(({ id, name, value }, i) => (
            <div key={id} className="apl-wallet__lineitems--item">
              <span className={`apl-wallet__lineitems--bullet apl-wallet__colour--${i}`}>
                {"\u2022"}
              </span>
              <h5>
                <FormattedMessage id={name} defaultMessage={name} />
              </h5>
              <p className="apl-wallet__benefits">
                <StandardMoney value={value} currency={currency} postfix />
              </p>
            </div>
          ))}
        </div>
      </section>
      <section className="apl-wallet__progressbarwrapper">
        <p className="apl-wallet__progressbarwrapper--text label">{remainingText}</p>
        <ProgressBar
          className="apl-wallet__progressbarwrapper--progressbar"
          balanceState={
            ["low", "medium", "high"][Math.max(Math.min(Math.floor(balanceRatio * 3), 2), 0)]
          }
          min={0}
          max={totalBalance}
          current={spentAmount}
        />
        <p className="apl-wallet__progressbarwrapper--text">
          <StandardMoney value={remainingBalanceValue} currency={currency} postfix />
        </p>
      </section>

      <footer>
        {isShowingButton && (
          <p className="apl-wallet__footer--button">
            <Button primary submitting={isSaving} onClick={onClick} style={{ width: "100%" }}>
              {buttonText}
            </Button>
          </p>
        )}
        <p className="apl-wallet__footer--subtext">{subtext}</p>
      </footer>
    </article>
  );
};

Wallet.propTypes = {
  ...walletProps,
};

export default Wallet;



// WEBPACK FOOTER //
// ./components/employee/shop/Wallet.js